<ct-model [configuration]="configuration"></ct-model>
<app-scheduler-legend></app-scheduler-legend>